import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export const invoiceGroupBysSelector = () => createSelector(
  [getUseQueryResultData<string[]>],
  (data,) => {
    return selectInvoiceGroupBysAndTransform(
      data ?? []
    );
  }
);

export const invoiceGroupBySelector = () => createSelector(
  [getUseQueryResultData<string>],
  (data) => {
    return data ? transformInvoiceGroupBy(data) : undefined;
  }
);

export const selectInvoiceGroupBys = (values?: string[]): string[] => {
  if (!values) {
    return [];
  }

  return values
};

export const transformInvoiceGroupBy = (value: string): string => {
  return value
}

export const selectInvoiceGroupBysAndTransform = (values?: string[]): string[] => {
  const selected = selectInvoiceGroupBys(values);
  return selected.map(transformInvoiceGroupBy);
};
